export default "__VITE_ASSET__Bl86L5t4__"